import React from 'react'
import LeftmenuIn from '../Components/LeftmenuIn'
import DashnavIn from '../Components/DashnavIn'
import ChatComp from './ChatComp'

function Chat() {
  return (
    <div>
        <div className='mainContainer'>
            <LeftmenuIn/>
            <div className='theMainContainer'>
              <DashnavIn/>
              <ChatComp/>
     
            </div>
        </div>  
    </div>
  )
}

export default Chat